import { UserAPI } from "API/userApi";
import { IPerson } from "interfaces/interfaces";
import { setTimeoutAsync } from "./helpers";
import { resizeImages } from "./resizeImages";
import {
  FILE_UPLOAD_IMAGES_ALLOWED_MIME_TYPES,
  FILE_UPLOAD_IMAGES_MAX_FILE_SIZE
} from "../config/common";

const numberAttempts = 3;
const delay = 2 * 1000;

export const tryLoadAvatar = async (
  userID: string,
  colAttempts: number = 3
): Promise<[string, boolean]> => {
  let response;
  for (let _ = 0; _ < colAttempts; _++) {
    response = await setTimeoutAsync(async () => {
      const user: IPerson = await UserAPI.getUser(userID);

      return [
        (user && user.hasOwnProperty("thumbnail_url")
          ? user.thumbnail_url
          : "") as string,
        user.is_profile_complete
      ];
    }, delay);

    if (!!(response as [string, boolean])[0].length)
      return response as [string, boolean];
  }
  return ["", false];
};

export const uploadAvatar = async (
  avatar: File | undefined,
  userID: string | undefined
): Promise<[string, boolean | undefined]> => {
  if (!avatar || !userID?.length) return ["", undefined];

  const newImg = await resizeImages([avatar]);
  if (!newImg.length) return ["", false];

  const responseUpload = await UserAPI.uploadAvatar(userID, newImg[0], {
    showNotificationOnError: false
  });

  if (responseUpload.hasOwnProperty("success") && responseUpload.success) {
    return await tryLoadAvatar(userID, numberAttempts);
  }
  return ["invalid_type", false];
};

export const getFileUploadImageAllowedExtensions = () => {
  return FILE_UPLOAD_IMAGES_ALLOWED_MIME_TYPES.split(", ").map(
    (type) => type.split("/")[1]
  );
};

export const getFileUploadImageAllowedExtensionsLabel = () => {
  return getFileUploadImageAllowedExtensions()
    .map((v) => v.toUpperCase())
    .join(", ");
};

export const getMaxImageUploadSizeLabel = () => {
  return Math.round(FILE_UPLOAD_IMAGES_MAX_FILE_SIZE / (1024 * 1024)) + "mb";
};
